import React, { useState, useEffect, useRef } from "react";
import "./SlideDrawer.css";
import ConfirmDialog from "../ConfirmDialog2/ConfirmDialog2";

const SlideDrawer = ({
  children,
  triggerButton,
  width = "75%",
  height = "93vh",
  position = "right",
  isClosable = true,
  showConfirmOnClose = false,
  closeOnOverlayClick = true,
  closeOnEscape = true,
  showCloseButton = true,
  isOpenExternal = undefined,
  onOpenChange,
  confirmTitle = "Confirm Close",
  confirmMessage = "Are you sure you want to close? Any unsaved changes will be lost.",
  onOpen,
  onClose,
  onBeforeClose,
  onBeforeOpen = {
    validate: () => true,
    onFail: () => {},
  },
  defaultOpen = false,
  customStyles = {
    drawer: {},
    overlay: {},
    closeButton: {},
    confirmDialog: {},
  },
}) => {
  const [isOpenInternal, setIsOpenInternal] = useState(defaultOpen);
  const [isRendered, setIsRendered] = useState(defaultOpen);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const drawerRef = useRef(null);

  const isControlled = isOpenExternal !== undefined;
  const isOpen = isControlled ? isOpenExternal : isOpenInternal;

  useEffect(() => {
    if (isControlled) {
      setIsRendered(isOpenExternal);
    }
  }, [isOpenExternal, isControlled]);

  // useEffect(() => {
  //   const handleEscape = (e) => {
  //     if (e.key === "Escape" && isOpen && closeOnEscape) {
  //       initiateClose();
  //     }
  //   };

  //   if (isOpen) {
  //     document.addEventListener("keydown", handleEscape);
  //     document.body.style.overflow = "hidden";
  //   }

  //   return () => {
  //     document.removeEventListener("keydown", handleEscape);
  //     document.body.style.overflow = "visible";
  //   };
  // }, [isOpen, closeOnEscape]);

  const handleOpen = () => {
    if (typeof onBeforeOpen === "object") {
      const canOpen = onBeforeOpen.validate();
      if (!canOpen) {
        if (onBeforeOpen.onFail) onBeforeOpen.onFail();
        return;
      }
    }

    setIsRendered(true);
    requestAnimationFrame(() => {
      if (!isControlled) {
        setIsOpenInternal(true);
      }
      if (onOpenChange) {
        onOpenChange(true);
      }
      if (onOpen) onOpen();
    });
  };

  const initiateClose = () => {
    if (showConfirmOnClose) {
      setShowConfirmDialog(true);
    } else {
      handleClose();
    }
  };

  const handleClose = async () => {
    if (onBeforeClose) {
      const shouldClose = await onBeforeClose();
      if (!shouldClose) return;
    }

    if (!isControlled) {
      setIsOpenInternal(false);
    }
    if (onOpenChange) {
      onOpenChange(false);
    }
    setShowConfirmDialog(false);

    setTimeout(() => {
      setIsRendered(false);
      if (onClose) onClose();
    }, 200);
  };

  const getDrawerStyle = () => {
    const baseStyle = {
      width,
      height,
      [position]: "-100%",
      ...customStyles.drawer,
    };

    if (isOpen) {
      baseStyle[position] = "0";
    }

    return baseStyle;
  };

  return (
    <div className="slide-drawer-container">
      {React.cloneElement(triggerButton, { onClick: handleOpen })}

      {isRendered && (
        <>
          <div
            className={`slide-drawer-overlay ${
              isOpen ? "overlay-visible" : "overlay-hidden"
            }`}
            onClick={() => closeOnOverlayClick && initiateClose()}
            style={customStyles.overlay}
          />

          <div
            ref={drawerRef}
            className={`slide-drawer ${isOpen ? "drawer-open" : ""}`}
            style={getDrawerStyle()}
          >
            {showCloseButton && isClosable && (
              <button
                className="slide-drawer-close btn"
                id="close-slide-drawer"
                onClick={initiateClose}
                aria-label="Close drawer"
                style={customStyles.closeButton}
              >
                ×
              </button>
            )}

            {children}
          </div>

          <ConfirmDialog
            isOpen={showConfirmDialog}
            title={confirmTitle}
            message={confirmMessage}
            onConfirm={handleClose}
            onClose={() => setShowConfirmDialog(false)}
            confirmText="Yes, close"
            cancelText="Cancel"
            variant="warning"
          />
        </>
      )}
    </div>
  );
};

export default SlideDrawer;
